(function(){
'use strict';

angular.module('classy').component('modalTitle', {
  template: '<h2 class="modal__title" data-ng-transclude></div>',
  transclude: true
});
})();